/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 4/26/15
 * Time: 10:39 AM
 * To change this template use File | Settings | File Templates.
 * please replace YourModuleName with the module name you are coding in
 */
define(function (require) {
    "use strict";

    /************************** require region *****************************************/
    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var Logger = require("logger");
    //Template
    var template = require("ui/radio-button-list/templates/radioButtonItemView.tmpl");
    //utilities

    //ui components
    var Bubble = require("ui/bubble/Bubble");
    //Constants  CAPITAL letters with underscore
    /************************** Constants *****************************************/
    var CLASSES = {
        SELECTED: "radio-selected",
        DISABLED: "disabled"
    };

    var RadioButtonItemView = Marionette.Layout.extend({

        /************************** extended json definitions *****************************************/
        template: template,
        withUIComponents: true,
        tagName: "li",
        className: "item-wrapper",
        ui: {
            radioButtonItem: "button.circle-radio",
            radioButtonLabel: ".radio-button-label",
            embeddedViewWrapper: ".embedded-view-wrapper"
        },
        regions: {
            embeddedViewRegion:  ".embedded-view-wrapper"
        },
        events: {
            "click @ui.radioButtonLabel":"_itemClicked",
            "click @ui.radioButtonItem":"_itemClicked",
            "click @ui.embeddedViewWrapper":"_itemClicked"
        },
        modelEvents: {
            "change:enabled": "_renderEnabled",
            "change:checked": "_renderChecked"
        },


        /************************** Marionette overriden functions *****************************************/
        initialize: function (options) {
            this.logger = Logger.getLogger("RadioButtonList");
            this.logger.debug("Initializing RadioButtonItemView", "RadioButtonItemView:initialize");
            this.allowHtml = options.allowHtml;
        },
        customTemplateHelpers: function () {
            return {
                allowHtml: this.allowHtml
            };
        },
        onRender: function () {
            this.logger.debug("Rendering RadioButtonItemView", "RadioButtonItemView:onRender");
            this.$el.attr("data-key", this.model.id);
            this._renderTooltip();
            this._showLabelAndView(); //attention order matters must come before the enabled/checked func
            this._renderEnabled();
            this._renderChecked();
            this._defineBubbleEvents();
        },
        onClose: function () {
            this.logger.debug("closing RadioButtonItemView", "RadioButtonItemView:onClose");
        },
        /************************** Public functions *****************************************/

        /************************** private functions *****************************************/

        _showLabelAndView: function (){
            this.embeddedView = this.model.getEmbeddedView();
            if (this.embeddedView){
                if (this.model.getLabel() !== this.model.EMPTY_LABEL){
                    this.$el.addClass("label-and-view");
                    this._renderEmbeddedView();
                }
                else{
                    this.$el.addClass("view-only");
                    this._renderEmbeddedView();
                }
            }
            else{
                this.$el.addClass("label-only");
            }

        },

        //render functions:
        _renderEmbeddedView: function(){
            this.embeddedViewRegion.show(this.embeddedView);
        },
        _renderTooltip: function(){
            if (this.model.isTooltipDefined()){
                var tooltipTarget = this.ui.radioButtonLabel;
                if (tooltipTarget) {
                    tooltipTarget.attr("title", this.model.getTooltip());
                    tooltipTarget.attr("tooltip-align", this.model.getTooltipAlign());
                    tooltipTarget.attr("tooltip-position", this.model.getTooltipPosition());
                }
            }
        },
        _defineBubbleEvents: function(){
            if (this.model.isBubbleDefined()){
                var _this = this;
                this.ui.radioButtonLabel.mouseenter(function(){
                    _this._showBubble();
                });
                this.ui.radioButtonLabel.mouseleave(function(){
                    _this._hideBubble();
                });
            }
        },
        _showBubble: function(){
            if (!_.has(this.uiComponents, "bubble")){
                this._createBubble();
            }
        },
        _hideBubble: function(){
            if (_.has(this.uiComponents, "bubble")){
                this.uiComponents.bubble.close();
            }
        },
        _createBubble: function(){
            if (this.model.isBubbleDefined()){
                var bubbleOptions = {
                    targetControl:this.ui.radioButtonLabel,
                    position:this.model.getBubblePosition(),
                    align: this.model.getBubbleAlign(),
                    showCloseButton:false
                };
                if (this.model.isBubbleTextDefined()){
                    bubbleOptions.text = this.model.getBubbleText();
                }
                else if (this.model.isBubbleContentViewDefined()){
                    bubbleOptions.contentView = this.model.getBubbleContentView();
                }
                this.uiComponents.host$.createAndRender("bubble", {
                    type:Bubble,
                    options: bubbleOptions
                });
            }
        },
        _renderEnabled: function () {
            var enabled = this.model.getEnabled();
            this.$el.toggleClass(CLASSES.DISABLED, !enabled);
            this._enableEmbeddedView(enabled);

        },
        _renderChecked: function () {
            var checked =   this.model.getSelected();
            this.ui.radioButtonItem.toggleClass(CLASSES.SELECTED, checked);
            this._enableEmbeddedView(checked);
            this._focusEmbeddedView(checked);
        },
        _enableEmbeddedView: function(enabled){
            if (this.embeddedView && _.isFunction(this.embeddedView.setEnabled)) {
                this.embeddedView.setEnabled(enabled);
            }
        },
        _focusEmbeddedView: function(focus){
            if (this.embeddedView && _.isFunction(this.embeddedView.setFocus)) {
                this.embeddedView.setFocus(focus);
            }
        },
        _itemClicked: function(event){
            this.trigger("itemClicked");
        }


    });

    return RadioButtonItemView;

});
